<div 
class="template" 
*ngIf="form_ads.template" 
[innerHTML]="form_ads.template.css + htmlTemp | safe: 'html'"
></div>
